export var ScimRequestAction;
(function (ScimRequestAction) {
    ScimRequestAction["CREATE_USER"] = "create_user";
    ScimRequestAction["UPDATE_USER"] = "update_user";
    ScimRequestAction["DEACTIVATE_USER"] = "deactivate_user";
    ScimRequestAction["DELETE_USER"] = "delete_user";
    ScimRequestAction["ROLE_CHANGE"] = "role_change";
    ScimRequestAction["MEMBERSHIP_CHANGE"] = "membership_change";
    ScimRequestAction["CREATE_GROUP"] = "create_group";
    ScimRequestAction["UPDATE_GROUP"] = "update_group";
    ScimRequestAction["DELETE_GROUP"] = "delete_group";
    ScimRequestAction["LOOKUP"] = "lookup";
    ScimRequestAction["LIST"] = "list";
    ScimRequestAction["UNKNOWN"] = "unknown";
})(ScimRequestAction || (ScimRequestAction = {}));
//# sourceMappingURL=requestLogs.js.map